import { Show } from "solid-js";
import { ActionDropdown, ActionDropdownMenuItemLink, ActivateDropdownItem, DeactivateDropdownItem, DeleteDropdownItem, EditDropdownMenuItemLink } from "../../components/ui/actions/ActionDropdown";
import { EditAction } from "../../components/ui/actions";
import { activateAction, deactivateAction, deleteAction } from "../../components/ui/actions/config";
import { ListRow } from "../../components/ui/list/ListRow";
import { Badge } from "@/components/ui/Badge";

import {
  TableCell,
} from "@/components/shadcn/table";

export default function TherapyRow(props) {

  const row = props.item;

  const actionUrl = 'therapy';
  const entity = 'therapy';

  const onAction = (key) => {
    if (key === 'deactivate') {
      props.onAction(deactivateAction(actionUrl, entity), row.key);
      return;
    }

    if (key === 'activate') {
      props.onAction(activateAction(actionUrl, entity), row.key);
      return;
    }

    if (key === 'delete') {
      props.onAction(deleteAction(actionUrl, entity), row.key);
      return;
    }
  }

  const onHandle = () => {
  }

  return (
    <ListRow items={props.items} key={row.key} action={true} move={false} onToggle={(key) => props.onCheck(key)} onHandle={onHandle}>
      <TableCell>
        <h4 class="m-0 text-bold text-lg mb-0">
          <a class="kq_search" href="#">{row.brand} {row.name}</a>
        </h4>
        Duration: <Badge variant="success">{row.duration}</Badge> <br />
        Created At: <Badge variant="success">{row.createdAt}</Badge>
      </TableCell>
      <TableCell>
        <div class="single-stat-box pull-left">
          <Badge variant='success'>{row.targetConditions}</Badge>
          <br />
          <span class="text-muted-foreground">Target Conditions</span>
        </div>
      </TableCell>
      <TableCell>
        <div class="single-stat-box pull-left">
          <Badge variant={row.isActive ? 'success' : 'warning'}>{row.isActive ? 'Active' : 'Inactive'}</Badge>
          <br />
          <span class="text-muted-foreground">Status</span>
        </div>
      </TableCell>
      <TableCell class="text-right">
        <div class="flex gap-2 items-center">
          <ActionDropdown asIcon>
            <EditDropdownMenuItemLink url={actionUrl} key={row.key} />
            <ActionDropdownMenuItemLink icon="carbon:prompt-session" href={`/therapy/${row.key}/sessions`}>Sessions</ActionDropdownMenuItemLink>
            <Show when={!row.isActive}>
              <ActivateDropdownItem onClick={() => { onAction('activate') }} />
            </Show>
            <Show when={row.isActive}>
              <DeactivateDropdownItem onClick={() => { onAction('deactivate') }} />
            </Show>
            <DeleteDropdownItem onClick={() => { onAction('delete') }} />
          </ActionDropdown>
        </div>
      </TableCell>
    </ListRow>
  );
}
